/**
 * Primary (left) mouse button only. Touch and pen always allowed so mobile keeps working.
 * @param {import('pixi.js').FederatedPointerEvent | PointerEvent | MouseEvent} e
 */
export function isPrimaryPointerAction(e) {
  if (!e) return false;
  const pt = e.pointerType ?? e.nativeEvent?.pointerType;
  if (pt === 'touch' || pt === 'pen') return true;
  const b = e.button;
  return b === 0;
}
